//#region redux
import { useDispatch } from "react-redux";
import { surveySnoozed } from "store/actions/surveyActions";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
import { useSnoozeAction } from "components/common";
import { LocalizationHelperInstance } from "utils/helpers";

function useSurveySnoozeAction(id: string, markAsDone: (id: string) => void) {
  const dispatch = useDispatch();

  const onSnoozeSurveySuccess = () => {
    dispatch(surveySnoozed(id));
    markAsDone(id);
  };

  const { snoozeAction, snoozeActionDialog } = useSnoozeAction(
    id,
    WintSuperkollAPIModel.TodoType.Survey,
    onSnoozeSurveySuccess,
    LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Survey.SnoozeSurvey)
  );

  return { snoozeAction, snoozeActionDialog };
}

export default useSurveySnoozeAction;
